import { Component, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { Input, forwardRef } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, } from "@angular/forms";
import { Output, EventEmitter } from '@angular/core';

// refs: https://almerosteyn.com/2016/04/linkup-custom-control-to-ngcontrol-ngmodel

@Component({
    selector: 'ui-input',
    templateUrl:'./ui-input.html',
    styleUrls: [ 
        './ui-input.scss'
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UiInput),
            multi: true
        }            
    ]
})
export class UiInput implements ControlValueAccessor, OnInit, OnChanges, OnDestroy {
    @Input('placeholder') _placeholder = '';
    @Input('formControlName') _name = '';
    @Input('readonly') _readonly = false;
    @Input('disabled') _disabled = false;
    @Input('type') _type = '';
    @Input('kiosk') _kiosk = true;
    @Input('title') _title = '';
    @Input('value') _value = '';
    @Input('autocomplete') _autocomplete = 'do-not-autofill';
    
    @Input('formgroup') _formgroup = null
    @Input('errornfo') _errornfo = {} 
    
    private _innerValue: any = '';  
    private _onChangeCallback: any = () => {}
    private _onTouchCallback: any = () => {}
    
    public _data = {
        title: '',
        showTitle: false,
    }

    @ViewChild('input', {static: false}) _input: any;   
    OnKeyPress(key){
        if (this._input){
            this._input.OnKeyPress(key);
        }
    }

    SetFocus(){
        if (this._input){
            this._input.SetFocus();
        }
    }

    constructor() {
        // nothing to do
    }

    private _form_subscription = null;
    ngOnInit() {
        this._innerValue = this._value;
        if (this._formgroup && this._name){
            this._form_subscription = this._formgroup.get(this._name).valueChanges.subscribe(
            data => {
                this._value = this._innerValue;
            });        
        }

        this.onChange();
    }

    ngOnChanges() {
        this.onChange();
    }
    
    ngOnDestroy() {
        if (this._form_subscription){
            this._form_subscription.unsubscribe();
            this._form_subscription = null;
        }        
    }

    @Output('onChange') _onChange = new EventEmitter<any>(); 
    onChange() {
        this._data.title = (this._title == '') ? this._placeholder : this._title;
        this._data.showTitle = (this._innerValue !== null) && (this._innerValue !== '');
        this._onChange.emit();
    }

    @Output('change') _changed = new EventEmitter<any>(); 
    isChanged(){
        this._changed.emit();
    }

    @Output('onFocus') _onFocus = new EventEmitter<any>(); 
    onFocus() {
        this._onFocus.emit();
    }

    /********************************************/
    /* disable control                          */
    /********************************************/

    get disabled(){
        // if directly disabled, return true
        if (this._disabled){
            return true;
        }

        // check if the the form control is disabled
        if (this._formgroup && this._name){
            return this._formgroup.get(this._name).disabled;
        }

        // not disabled
        return false;
    }

    /********************************************/
    /* get/set accesors                         */
    /********************************************/
    
    get value(): any {
        return (this._innerValue) || (this._innerValue === 0) ? this._innerValue.toString() : null;
    }

    set value(v: any) {
        if (v !== this._innerValue) {
            this._innerValue = v;

            this._onChangeCallback(v);
            this._onTouchCallback();
        }
    }    
    
    /********************************************/
    /* ControlValueAccessor                     */
    /********************************************/
    
    writeValue(value: any) {
        if (value !== this._innerValue) {
            this.value = value;
            this.onChange();
        }        
    }

    registerOnChange(fn: any) {
        this._onChangeCallback = fn;
    }

    registerOnTouched(fn: any) {
        this._onTouchCallback = fn;
    }

}